import type { ProjectionRow, Transaction } from "./types";

function escapeCsvField(value: string | number | boolean): string {
  const s = String(value);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function transactionsToCsv(transactions: Transaction[]): string {
  const header = ["booking_date", "value_date", "text", "amount", "source"];
  const lines = [header.join(",")];
  for (const t of transactions) {
    lines.push(
      [
        t.booking_date,
        t.value_date,
        escapeCsvField(t.text),
        t.amount.toFixed(2),
        t.source,
      ].join(","),
    );
  }
  return lines.join("\n") + "\n";
}

export function projectionToCsv(rows: ProjectionRow[]): string {
  if (rows.length === 0) return "";
  const keys = Object.keys(rows[0]) as (keyof ProjectionRow)[];
  const lines = [keys.join(",")];
  for (const row of rows) {
    lines.push(keys.map((k) => escapeCsvField(row[k])).join(","));
  }
  return lines.join("\n") + "\n";
}
